import styled, { css } from 'styled-components';
import { colors, fonts } from 'assets/styled/tokens';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';

export const CalendarContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  min-height: 70vh;
`;

export const CalendarToolBar = styled.div`
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  border-bottom: none;
`;

export const ViewsButtonsContainer = styled.div`
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const ToolBarFirstRow = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
`;

export const NavigateCalendarButtonsContainer = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  max-width: 250px;
`;

export const TipoboxWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px;
  overflow: hidden;
`;

const TIPOBOX_GRAY_50 = '#FAF9F8';
const TIPOBOX_GRAY_200 = '#E8E1DE';
const SPACING_25 = 4;
const SPACING_50 = 8;

export const Tipobox = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING_50}px;
  height: 24px;
  max-width: 100%;
  min-width: 0;
  padding: ${SPACING_25}px ${SPACING_50}px;
  background: ${TIPOBOX_GRAY_50};
  border: 1px solid ${TIPOBOX_GRAY_200};
  border-radius: 4px;
  box-sizing: border-box;
  font-family: Roboto;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
  overflow: hidden;
  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    path {
      fill: ${colors.carbon};
    }
  }
`;

export const TipoboxText = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  strong {
    font-weight: 700;
  }
`;

export const FiltersButtonContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const FiltersGridWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;
export const FiltersGridColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FilterCell = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const UnidadesFieldWrapper = styled.div`
  width: 100%;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  & > div {
    height: 24px !important;
    min-height: 24px !important;
  }
  & > div > div:first-child {
    height: 24px !important;
    min-height: 24px !important;
    padding: 2px 12px !important;
    box-sizing: border-box !important;
  }
  & > div > div:first-child > div:first-of-type {
    gap: 10px !important;
  }
`;

export const TodayButton = styled.button`
  width: 46px;
  height: 24px;
  border: 1px solid ${colors.primary};
  color: ${colors.primary};
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
`;

export const PrevNextButton = styled.button`
  height: 24px;
  width: 24px;
  border: none;
  cursor: pointer;
  svg {
    path {
      fill: ${colors.carbon};
    }
  }
`;

export const MonthYearContainer = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
`;

export const FiltersButton = styled.button`
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.5px;
  color: ${colors.carbon};
  min-width: 110px;
  height: 24px;

  svg path {
    fill: #9e9288;
  }
`;

export const TypeFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TypeButton = styled.button<{ isActive?: boolean; isRight?: boolean }>`
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  min-width: 76px;
  padding: 2px 12px;
  font-family: Roboto;
  font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isActive }) =>
    isActive &&
    `
     border: 1px solid ${colors.carbon};
    `}
  ${({ isActive, isRight }) =>
    !isActive &&
    isRight &&
    `
     border: 1px solid ${colors.gray};
     border-left: none;
    `}
    ${({ isActive, isRight }) =>
    !isActive &&
    !isRight &&
    `
     border: 1px solid ${colors.gray};
     border-right: none;
    `}
  color: ${({ isActive }) => (isActive ? colors.carbon : colors.gray)};
  :first-of-type {
    border-radius: 4px 0 0 4px;
  }
  :last-of-type {
    border-radius: 0 4px 4px 0;
  }
`;

export const OpenModalButton = styled.button<{ width?: string; size?: string }>`
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  justify-content: space-between;
  text-align: left;
  overflow: hidden;
  font-weight: 400;
  color: ${colors.gray};
  font-size: 14px;
  gap: 10px;
  box-sizing: border-box;
  ${props => {
    const size = props.size || 'md';
    if (size === 'small' || size === 'sm') {
      return css`
        min-height: 24px;
        height: 24px;
        padding: 2px 12px;
      `;
    }
    return inputStyleFactory(size as any);
  }}
  > :first-child {
    flex: 1;
    min-width: 0;
  }
  > svg:last-of-type {
    flex-shrink: 0;
  }
  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const CalendarContentWrapper = styled.div`
  position: relative;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    width: 100%;
    min-width: 0;
  }
`;

export const CalendarLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0 0 8px 8px;
  z-index: 1;
`;

// Seta de navegação por dia – dentro do header da primeira/última coluna (Figma)
export const DayHeaderNavButton = styled.button<{ side: 'left' | 'right' }>`
  width: 24px;
  height: 40px;
  flex-shrink: 0;
  align-self: flex-start;
  border: 1px solid #e5e5e5;
  border-top: none;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
  transition: background-color 0.15s ease;

  ${({ side }) =>
    side === 'left'
      ? 'margin-left: -4px; border-left: none; border-top-right-radius: none; border-bottom-right-radius: 4px;'
      : 'margin-right: -4px; border-right: none; border-top-right-radius: 4px; border-bottom-right-radius: none; border-bottom-left-radius: 4px;'}

  &:hover {
    background-color: #f5f3f1;
  }

  &:focus {
    outline: none;
  }

  svg {
    display: block;
  }
`;

// Componentes styled do WeekView
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(100px, 1fr));
  width: 100%;
  min-height: 70vh;
  min-width: 0;
  box-sizing: border-box;
`;

const DROP_TARGET_BG = '#F5F3F1';
const DROP_TARGET_BORDER = '#DAD1CD';

export const DayContainer = styled.div<{
  isFirst?: boolean;
  isLast?: boolean;
  isHighlighted?: boolean;
  removeLeftBorder?: boolean;
  isWeekend?: boolean;
  isDropTarget?: boolean;
}>`
  min-width: 0;
  min-height: 150px;
  background-color: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  padding: 0;
  position: relative;
  ${({ isFirst }) =>
    isFirst &&
    `
      border-left: none;
      border-radius: 0 0 0 8px;
    `}

  ${({ isLast }) =>
    isLast &&
    `  border-right: none;
      border-radius: 0 0 8px 0;
    `}

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    border: 1px solid ${colors.primary};
  `}

  ${({ removeLeftBorder }) =>
    removeLeftBorder &&
    `
    border-left: none;
  `}
    ${({ isWeekend }) =>
    isWeekend &&
    `
    background-color: #FBFAF9 !important;
  `}

  ${({ isDropTarget }) =>
    isDropTarget &&
    `
    background: ${DROP_TARGET_BG};
    border: 1px solid ${DROP_TARGET_BORDER};
  `}
`;

export const DayColumnHeader = styled.div<{ $hasLeftArrow?: boolean; $hasRightArrow?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: ${({ $hasLeftArrow, $hasRightArrow }) =>
    $hasLeftArrow ? 'flex-start' : $hasRightArrow ? 'flex-end' : 'center'};
  padding: 0 4px 8px 4px;
  gap: 0;
  height: 48px;
  min-height: 48px;
  box-sizing: border-box;
`;

export const DayColumnHeaderContent = styled.div<{ $grow?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: ${({ $grow }) => ($grow ? '1' : '0 0 auto')};
  min-width: 0;
  padding-top: 8px;
`;

export const DayLabel = styled.label<{ isHighlighted?: boolean; isBlack?: boolean }>`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.gray};
  margin-bottom: 4px;
  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    color: ${colors.darkPrimary};
  `}
  ${({ isBlack }) =>
    isBlack &&
    `
    color: ${colors.carbon};
  `}
`;

export const ExpectedHours = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.gray};
`;

export const IsTodayLabel = styled.div<{ $hasLeftArrow?: boolean }>`
  position: absolute;
  top: ${({ $hasLeftArrow }) => ($hasLeftArrow ? '40px' : '0')};
  left: 0;
  width: 33px;
  height: 16px;
  background-color: #dc7d00;
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.white};
  border-radius: ${({ $hasLeftArrow }) => ($hasLeftArrow ? '0 4px 4px 0' : '0 0 4px 0')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DayColumnBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0px 8px 24px 8px;
`;

// Mobile week calendar (sticky at top on mobile)
export const MobileWeekCalendarWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0px 1px 8px 0px #0000001a;
  padding: 12px 16px;
  margin-bottom: 0;
  border: 1px solid #e5e5e5;
`;

export const MobileWeekCalendarNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const MobileWeekCalendarNavButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 4px;
  &:hover {
    background-color: ${colors.pampas};
  }
  svg path {
    fill: ${colors.carbon};
  }
`;

export const MobileWeekCalendarMonthYear = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
`;

export const MobileWeekCalendarDaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  text-align: center;
`;

export const MobileWeekCalendarDayLabel = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.gray};
  margin-bottom: 4px;
`;

/** Botão do dia: área de toque; o anel circular fica só no número (MobileWeekCalendarDayNumberRing). */
export const MobileWeekCalendarDayCell = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 0 0;
  border: none;
  background: transparent;
  cursor: pointer;
  min-width: 44px;
  min-height: 58px;
  position: relative;
  box-sizing: border-box;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.carbon};
`;

export const MobileWeekCalendarTodayRingWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  position: relative;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.primary};
`;

/** Círculo fixo ao redor do número: estado selecionado (laranja preenchido) ou padrão (sem borda). */
export const MobileWeekCalendarDayNumberRing = styled.span<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid transparent;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.carbon};

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background-color: ${colors.primary};
    color: ${colors.white};
    border-color: ${colors.primary};
  `}
`;

const DOT_RED = '#E74C3C';
const DOT_BLUE = '#2780EB';

export const MobileWeekCalendarDot = styled.div<{ $dotType: 'red' | 'blue' | 'none' }>`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  position: absolute;
  top: 33px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ $dotType }) =>
    $dotType === 'red' ? DOT_RED : $dotType === 'blue' ? DOT_BLUE : 'transparent'};
  visibility: ${({ $dotType }) => ($dotType !== 'none' ? 'visible' : 'hidden')};
`;

// Mobile toolbar (tabs + Filtros button) and filters area
export const MobileToolbarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e5e5e5;
  background-color: ${colors.white};
  flex-wrap: wrap;
`;

export const MobileFiltersExpandable = styled.div`
  border-top: 1px solid #e5e5e5;
  background-color: ${colors.white};
  ${FiltersGridWrapper} {
    flex-direction: column;
  }
`;

export const MobileDayListSection = styled.div`
  margin-top: 16px;
  padding: 0 16px 24px;
  position: relative;
  min-height: 120px;
`;

export const MobileAgendaEmptyDayRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 240px;
  padding: 24px 0 32px;
  box-sizing: border-box;
  gap: 16px;
`;

export const MobileAgendaEmptyDayMessage = styled.p`
  margin: 0;
  max-width: 311px;
  min-height: 24px;
  font-family: ${fonts.family.title};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  color: #dad1cd;
`;

export const MobileLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0 0 8px 8px;
  z-index: 1;
`;
